import React, { useState } from 'react'
import { UploadOutlined } from '@ant-design/icons'
import { Button, Upload } from 'antd'
import { toast } from 'react-toastify'

interface UploadProp {
  name: string
  action: string
  onSuccess: (response: any, file: any) => void
  onChange: ({ file }: { file: any }) => void
  withCredentials: any
}

interface IProps {
  closeFileModal: () => void
  uploadedFilesApi: any
}

const AddFile: React.FC<IProps> = ({ closeFileModal, uploadedFilesApi }) => {
  const [fileName, setFileName] = useState<string>('')

  const handleUploadSuccess = () => {
    toast.success('File uploaded successfully!')
    closeFileModal()
    uploadedFilesApi()
  }

  const handleFileChange = ({ file }: { file: any }) => {
    setFileName(file?.name)

    if (file.status === 'done') {
      setFileName(file?.name)
    } else if (file?.status === 'error') {
      toast.error(file?.response?.error)
      console.error('File upload failed:', file.response)
    }
  }

  const props: UploadProp = {
    name: 'file',
    action: `${process.env.REACT_APP_CSV_ANALYTICS_URL}/csv-analytics/upload`,
    onSuccess: handleUploadSuccess,
    onChange: handleFileChange,
    withCredentials: true
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        borderTop: '1px solid hsl(240, 17.4%, 91%)'
      }}
    >
      <label htmlFor='upload'>
        <p style={{ fontSize: '15px', color: 'hsl(240, 10.3%, 38%)', padding: '15px 0' }}>
          Your file should have a header as the first row and contain at least 2 columns and 20 rows
          of data.
        </p>
      </label>
      <div
        style={{
          cursor: 'pointer',
          border: '2px dashed hsl(218.8, 80.2%, 84.1%)',
          width: '100%',
          background: 'hsl(215, 75%, 96.9%)',
          borderRadius: '5px',
          color: 'hsl(240, 10.3%, 38%)'
        }}
      >
        <p
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            textAlign: 'center',
            padding: '32px',
            gap: '20px',
            paddingBottom: '60px'
          }}
        >
          <Upload {...props}>
            <Button
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                border: 'none',
                background: 'transparent'
              }}
              icon={<UploadOutlined style={{ fontSize: '25px' }} />}
            >
              <span>
                <span
                  style={{
                    borderBottom: '1px dashed hsl(218, 80.3%, 47.8%)',
                    color: 'hsl(218, 80.3%, 47.8%)',
                    fontSize: '14px'
                  }}
                >
                  Click to upload{' '}
                </span>
                or drag and drop <br></br> Excel, CSV
              </span>
            </Button>
          </Upload>
        </p>
        {fileName && (
          <p style={{ textAlign: 'center', color: 'hsl(240, 10.3%, 38%)' }}>
            Uploaded File: {fileName}
          </p>
        )}
      </div>
    </div>
  )
}

export default AddFile
